import React from "react";
import { Field } from "react-final-form";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { atLeastOneFieldRequired, required } from "../../../util/validators";
import { AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";
import { PayorSelector } from "../../../components/inputs/final_form/PayorSelector";

export const PayorMemberPrefixForm = ({ handleSubmit, submitting, showPrefixField = true }) => (
  <>
    <Field render={PayorSelector} label="Payor" name="payorId" validate={required} kept={true} />

    {showPrefixField && (
      <Field
        component={TextInput}
        validate={atLeastOneFieldRequired("memberIdPrefixRegex")}
        label="Payor Member ID Prefix"
        name="memberIdPrefix"
      />
    )}
    <Field
      component={TextInput}
      validate={atLeastOneFieldRequired("memberIdPrefix")}
      label="Payor Member ID Regex"
      name="memberIdPrefixRegex"
    />

    <Field isMulti component={AdminOptionableInput} resource="labs" searchParam="lab_name" label="Labs" name="labIds" kept={true} />

    <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
      Submit
    </LoadingButton>
  </>
);
